import { useCallback } from "react";
import { ChoiceButton } from "@ww-digital/web-foundations-react/modules";
import { useXS } from "@ww-digital/xs-sdk-react";

import t, { AsHtml } from "../../../../../utils/translate";
import Column from "../../../../Column";
import {
  TERMS_AND_CONDITIONS,
  TERMS_AND_CONDITIONS_ADDENDUM
} from "../../../constants";

import styles from "./styles.module.scss";

const Terms = ({ agreement, onChange, plan, compound }) => {
  const { attributes: { showCheckboxTerms = null } = {} } = useXS(
    "WPF1450_CLINICAL_CHECKOUT_LEGAL"
  );

  const getTerms = useCallback(() => {
    const termsAndConditions =
      plan.templateContentMap?.get(TERMS_AND_CONDITIONS);
    const addendum = plan.templateContentMap?.get(
      TERMS_AND_CONDITIONS_ADDENDUM
    );
    const addonAddendum = plan.addonTemplateContentMap?.get(
      TERMS_AND_CONDITIONS_ADDENDUM
    );

    const compoundTerms = (
      <AsHtml
        className={styles.conditions}
        value={t("COMPOUND_CHECKOUT_TERMS")}
        tagType="div"
      />
    );

    const ack = (
      <AsHtml
        value={t("CHECKOUT_ACKNOWLEDGEMENT_PRODUCT_CLINICAL_HTML")}
        tagType="div"
      />
    );

    const ackCheckbox = (
      <>
        <AsHtml
          value={t(
            `CHECKOUT_ACKNOWLEDGEMENT_TERMS_PRODUCT_CLINICAL_${compound ? "COMPOUND_" : ""}HTML`
          )}
          tagType="div"
        />
        <AsHtml
          value={t("CHECKOUT_ACKNOWLEDGEMENT_TERMS_PRODUCT_CLINICAL_HTML_2")}
          tagType="div"
        />
      </>
    );

    const terms =
      showCheckboxTerms !== "true" && termsAndConditions ? (
        <AsHtml
          className={styles.conditions}
          value={termsAndConditions}
          tagType="div"
        />
      ) : null;

    const addendumContent = addendum ? (
      <AsHtml className={styles.addendum} value={addendum} tagType="div" />
    ) : null;

    const addonAddendumContent = addonAddendum ? (
      <AsHtml className={styles.addendum} value={addonAddendum} tagType="div" />
    ) : null;

    const addendumContentDisplay = addonAddendumContent || addendumContent;

    return (
      <Column className={styles.terms}>
        {compound && <>{compoundTerms}</>}
        {ack && <>{ack}</>}
        <ChoiceButton
          type="checkbox"
          name="legalTerms"
          value={agreement}
          description={ackCheckbox}
          checked={agreement}
          onChange={onChange}
          className={styles.checkbox}
        />
        {addendumContentDisplay && <>{addendumContentDisplay}</>}
        {terms && <>{terms}</>}
      </Column>
    );
  }, [agreement, showCheckboxTerms]);

  return <>{getTerms()}</>;
};

export default Terms;
